













































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import homePage from "@/components/homePage.vue";
import landmarkFamily from "@/components/landmarkFamily.vue";
import enterpriseMien from "@/components/enterpriseMien.vue";
import cultureHeritage from "@/components/cultureHeritage.vue";
import vrVideo from "@/components/vrVideo.vue";
import landmarkShop from "@/components/landmarkShop.vue";
import policies from "@/components/policies.vue";
import { informationQueryListByPage, headerData } from "@/axios";

@Component({
  name: "landmarkVr",
  components: {
    "v-homePage": homePage,
    "v-landmarkFamily": landmarkFamily,
    "v-enterpriseMien": enterpriseMien,
    "v-cultureHeritage": cultureHeritage,
    "v-vrVideo": vrVideo,
    "v-landmarkShop": landmarkShop,
    "v-policies": policies,
  },
})
export default class extends Vue {
  // 导航索引
  private navIndex = 1;
  private navIndexOld = 1;
  private navData = [];
  private searchType: any = [
    {
      name: "资讯",
      id: 1,
    },
    {
      name: "地标",
      id: 2,
    },
    {
      name: "企业",
      id: 3,
    },
    {
      name: "商品",
      id: 4,
    },
    {
      name: "视频",
      id: 5,
    },
    {
      name: "VR",
      id: 6,
    },
  ];

  private searchTypeId: any = this.searchType[0].id;
  private page: any = 1;
  private page_size: any = 16;
  private listCount: any = 0;
  private searchTypeIndex: any = 0;
  private searchList: any = [];

  private searchValue: any = "";
  private searchValueTemp: any = "";

  private landmarkTitle: any = "";
  private landmarkId: any = "";

  created() {
    this.landmarkId = this.$route.query.landmarkId;

    headerData({
      landmark_id: this.landmarkId,
    }).then((res: any) => {
      let data = res.data.data;
      this.navData = data.headerData;
      this.landmarkTitle = data.title;
    });

    // if((this as any).$route.query.landmarkId){
    //   this.notLandmark = false;
    // } else {
    //   this.notLandmark = true;
    // }

    this.searchValue = (this as any).$route.query.searchValue;
    this.searchValueTemp = this.searchValue;

    if (this.searchValue.length != 0) {
      this.getData();
    }
  }

  private tabSearchTypeIndex(index: any, id: any) {
    this.searchTypeIndex = index;
    this.searchTypeId = id;
    this.page = 1;
    this.getData();
  }

  // 改变nav索引
  private changeNavIndex(id: any) {
    this.navIndex = id;
    if (id != 2) {
      this.navIndexOld = id;
    }
  }

  private getData() {
    informationQueryListByPage({
      search_param: this.searchValue,
      search_type: this.searchTypeId,
      page: this.page,
      page_size: this.page_size,
    }).then((res: any) => {
      var data = res.data.data;
      this.searchList = data.data;
      this.listCount = data.count;
    });
  }

  private closeLandmarkDialog() {
    this.landmarkDialogShow = false;
  }

  private landmarkDialogShow: any = false;
  private landmarkUrl: any = "";

  private showLandmark() {
    // var url = "https://cms.fjyoulunsw.com:9100/sign_vr/#/";
    var url =
      document.location.protocol +
      "//cms.fjyoulunsw.com/sign_vr_v2/#/aPicture?id=1";
    this.landmarkUrl = url;
    this.landmarkDialogShow = true;
  }

  private toLandmarkIndex(index: any) {
    if (index == 1) {
      this.showLandmark();
    } else {
      this.$router.push({
        path: "/",
      });
    }
  }

  private toIndex() {
    this.$router.push({
      path: "/",
    });
  }

  private toOther() {
    window.location.href = "https://cms.fjyoulunsw.com:9100/web_new/#/login";
  }

  private pageChange(page: any) {
    this.page = page;
    this.getData();
  }

  private dialogShow: any = false;
  private videoUrl: any = "";

  private vrdialogShow: any = false;
  private vrUrl: any = "";

  private showVideo(url: any) {
    this.videoUrl = url;
    this.dialogShow = true;
    // console.log(url)
  }

  private showVr(url: any) {
    this.vrUrl = url;
    this.vrdialogShow = true;
    // console.log(url)
  }

  private checkDetail(item: any) {
    // console.log('checkDetail----------',item)

    switch (this.searchTypeIndex) {
      case 0:
        this.$router.push({
          name: "Article",
          query: {
            type: "1",
            landmarkId: item.landmark_id,
            id: item.id,
          },
        });
        break;
      case 1:
        this.$router.push({
          path: "/landmarkIndex",
          query: {
            landmarkId: item.id,
          },
        });
        break;
      case 2:
        this.$router.push({
          name: "Article",
          query: {
            type: "2",
            landmarkId: item.landmark_id,
            id: item.id,
          },
        });
        break;
      case 3:
        window.open(item.jump_url, "_blank");
        break;
      case 4:
        this.showVideo(item.jump_url);
        break;
      case 5:
        this.showVr(item.jump_url);
        break;
      default:
        console.log("无匹配");
    }
  }

  private toSearch(value: any) {
    // this.searchValue = this.searchValueTemp;
    this.$router.push({
      path: "/search",
      query: { searchValue: value },
    });

    // this.searchTypeId= this.searchType[0].id;
    // this.searchTypeIndex= 0;
    // this.page = 1;

    // this.getData();
  }
}
